import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityViverosGrupoEspecieAddFailure,
  entityViverosGrupoEspecieAddRequest,
  entityViverosGrupoEspecieAddSuccess,
  entityViverosGrupoEspecieChangeRequest,
  entityViverosGrupoEspecieChangeSuccess,
  entityViverosGrupoEspecieDeleteFailure,
  entityViverosGrupoEspecieDeleteRequest,
  entityViverosGrupoEspecieDeleteSuccess,
  entityViverosGrupoEspecieLoadFailure,
  entityViverosGrupoEspecieLoadRequest,
  entityViverosGrupoEspecieLoadSuccess
} from './entity-viveros-grupo-especie.actions';

import { ViverosGrupoEspecieService } from './entity-viveros-grupo-especie.service';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class ViverosGrupoEspecieEffects {
  // load
  loadRequestViverosGrupoEspecie = createEffect(() =>
    this.actions$.pipe(
      ofType(entityViverosGrupoEspecieLoadRequest),
      mergeMap(() =>
        this.viverosGrupoEspecieService.getViverosGrupoEspecie().pipe(
          map((items) => entityViverosGrupoEspecieLoadSuccess({ items })),
          catchError((error) =>
            of(entityViverosGrupoEspecieLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestActividadGrupoEspecie = createEffect(() =>
    this.actions$.pipe(
      ofType(entityViverosGrupoEspecieAddRequest),
      switchMap((action) =>
        this.viverosGrupoEspecieService.addViveroGrupoEspecie(action.item).pipe(
          map((item) =>
            entityViverosGrupoEspecieAddSuccess({
              item: item
            })
          ),
          catchError((error) =>
            of(entityViverosGrupoEspecieAddFailure({ error }))
          )
        )
      )
    )
  );

  changeRequestGrupoEspecie = createEffect(() =>
    this.actions$.pipe(
      ofType(entityViverosGrupoEspecieChangeRequest),
      switchMap((action) =>
        this.viverosGrupoEspecieService.addViveroGrupoEspecie(action.item).pipe(
          map((item) =>
            entityViverosGrupoEspecieChangeSuccess({
              item: item
            })
          ),
          catchError((error) =>
            of(entityViverosGrupoEspecieAddFailure({ error }))
          )
        )
      )
    )
  );

  addSuccessActividadGrupoEspecie = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityViverosGrupoEspecieAddSuccess),
        // tap(() => this.router.navigate(['']))
        tap(() => null)
      ),
    { dispatch: false }
  );

  deleteRequestVivero = createEffect(() =>
    this.actions$.pipe(
      ofType(entityViverosGrupoEspecieDeleteRequest),
      mergeMap((action) =>
        this.viverosGrupoEspecieService.deleteVivero(action.item).pipe(
          map((item) => {
            this.alertService.success('Vivero eliminado correctamente.');
            return entityViverosGrupoEspecieDeleteSuccess({
              item: action.item
            });
          }),
          catchError((error) =>
            of(entityViverosGrupoEspecieDeleteFailure({ error }))
          )
        )
      )
    )
  );

  // change

  // delete

  constructor(
    private actions$: Actions,
    private viverosGrupoEspecieService: ViverosGrupoEspecieService,
    private alertService: NotificationService
  ) {
    this.viverosGrupoEspecieService.url = environment.apiUrl;
  }
}
